export default "__VITE_ASSET__DqbNLAU6__"